module.exports = __webpack_public_path__ + "img/rolls02.dba48553.jpg";